<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 22 21">
    <g>
      <path
        d="M9.42489 16.0588V14.2059H10.6602V14.8235H11.8955V14.2059H13.1308V16.0588H9.42489ZM21.7778 13.5882H20.5425V21H2.01313V13.5882H0.777832V3.70588H5.2496C6.41077 1.44529 8.72077 0 11.2778 0C13.8349 0 16.1572 1.44529 17.3061 3.70588H21.7778V13.5882ZM6.67019 3.70588H15.8855C14.8725 2.18647 13.1555 1.23529 11.2778 1.23529C9.40018 1.23529 7.68313 2.18647 6.67019 3.70588ZM19.3072 13.5882H3.24842V19.7647H19.3072V13.5882ZM20.5425 4.94118H2.01313V12.3529H20.5425V4.94118Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath>
        <rect width="21" height="21" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>
